import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "../../config";

export const articlesApi = createApi({
    reducerPath: "articlesApi",
    baseQuery: fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().clientAuth.authToken;
            if (token) {
                headers.set("Authorization", `Basic ${token}`);
            }
            return headers;
        },
    }),

    endpoints: (builder) => ({
        searchArticles: builder.query({
            query: (articleId) => {
                return {
                    url: `/articles?q=${articleId}`,
                    method: "GET",
                };
            },
        }),

    }),
});

export const { useSearchArticlesQuery } = articlesApi;